module.exports = __webpack_public_path__ + "img/TZ.cb1ae9ff.png";